import { render, staticRenderFns } from "./passwordResetPage.vue?vue&type=template&id=24c682ae"
import script from "./passwordResetPage.vue?vue&type=script&lang=js"
export * from "./passwordResetPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports